// src/firebase.js
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";

// Trivia Firebase config - used for both auth and data
const firebaseConfig = {
  apiKey: "AIzaSyBwbu__QDKnhurrBAnXVcC8-Igd2TJRWjE",
  authDomain: "trivia-rn.firebaseapp.com",
  databaseURL: "https://trivia-rn.firebaseio.com",
  projectId: "trivia-rn",
  storageBucket: "trivia-rn.appspot.com",
  appId: "1:462152016494:android:75267acf6de78e3e9cbc7f",
};

// Wordly Firebase Config (from kupigames-portal)
const wordlyFirebaseConfig = {
  apiKey: "AIzaSyCMaTWLkceh1XsGtkvHKcd_kci7kBjqsdc",
  authDomain: "kupigames.firebaseapp.com",
  projectId: "kupigames",
  storageBucket: "kupigames.firebasestorage.app",
  messagingSenderId: "56777277057",
  appId: "1:56777277057:web:d6f18d94e02d668ea2d780",
  measurementId: "G-XFHBX5GX67"
};

// Initialize Trivia (Default App)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Initialize Wordly (Named App)
let wordlyApp;
if (!firebase.apps.find(app => app.name === "wordly")) {
  wordlyApp = firebase.initializeApp(wordlyFirebaseConfig, "wordly");
} else {
  wordlyApp = firebase.app("wordly");
}

// Create Google Auth provider
const provider = new firebase.auth.GoogleAuthProvider();

// Export services
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const database = firebase.database();
export const storage = firebase.storage();
export const googleProvider = provider;

// Export Wordly Services
export const wordlyAuth = wordlyApp.auth();
export const wordlyFirestore = wordlyApp.firestore();

export default firebase;
